"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemCategoryPartialWithIdSchema = exports.ItemCategorySchema = exports.BaseItemCategorySchema = exports.CategoryChannelAssociationSchema = exports.CategoryTranslationSchema = exports.MarketSchema = void 0;
const zod_1 = require("zod");
const _1 = require(".");
const __1 = require("..");
exports.MarketSchema = zod_1.z.object({
    countryName: __1.ShortStringSchema,
    /**
     * ISO 3166-1 alpha-2 country code.
     *
     * @example 'US'
     */
    countryCodeISO31661Alpha2: __1.ShortStringSchema,
    /**
     * ISO 3166-1 alpha-3 country code.
     *
     * @example 'USA'
     */
    countryCodeISO31661Alpha3: __1.ShortStringSchema,
});
exports.CategoryTranslationSchema = zod_1.z.object({
    locale: __1.ShortStringSchema,
    nameTranslated: __1.ShortStringSchema,
});
exports.CategoryChannelAssociationSchema = zod_1.z.object({
    associatedChannel: zod_1.z.union([__1.ChannelSchema.partial().required({ id: true }), zod_1.z.string()]),
    associatedCategoryId: __1.ShortStringSchema,
    associatedChannelAdditionalData: zod_1.z.object({}).optional(),
});
exports.BaseItemCategorySchema = __1.BaseSchema.extend({
    name: __1.ShortStringSchema,
    parent: zod_1.z.lazy(() => exports.ItemCategorySchema).optional(),
    children: zod_1.z.array(zod_1.z.lazy(() => exports.ItemCategorySchema)).optional(),
    hasChildren: zod_1.z.boolean(),
    /**
     * Define if this category can be used to publish an item offer.
     *
     * High level categories aren't allowed to be used to publish an item offer.
     */
    isOfferAllowed: zod_1.z.boolean(),
    /**
     * Key value pairs of channel association to the category.
     *
     * The key is the associated channel id.
     * The value is the category channel association.
     */
    channelsAssociations: zod_1.z.record(exports.CategoryChannelAssociationSchema).optional(),
    /**
     * Define rules for {@link IItem} attributes.
     *
     * Each item on the list specifies if a given attributes is required or not.
     */
    attributesSettings: zod_1.z.array(_1.ItemAttributeSettingSchema).optional(),
    nameTranslations: zod_1.z.array(exports.CategoryTranslationSchema).optional(),
    /**
     * List of markets where this category should be available.
     */
    availableMarkets: zod_1.z.array(exports.MarketSchema).optional(),
    hasVariantsSupport: zod_1.z.boolean().optional(),
    status: zod_1.z.nativeEnum(__1.CategoryStatus),
});
exports.ItemCategorySchema = exports.BaseItemCategorySchema;
exports.ItemCategoryPartialWithIdSchema = exports.BaseItemCategorySchema.extend({
    parent: exports.BaseItemCategorySchema.partial().required({ id: true }).optional(),
    children: exports.BaseItemCategorySchema.partial()
        .required({ id: true })
        .extend({ parent: exports.BaseItemCategorySchema.partial().required({ id: true }).optional() })
        .array()
        .optional(),
})
    .partial()
    .required({ id: true });
//# sourceMappingURL=item-category.js.map